<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'IMPORT_AND_EXPORT.EXPORT' | translate }}</div>
                <div class="tools"></div>
            </div>
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a class="nav-link active" id="nav-retail-chains-tab" data-toggle="tab" href="#nav-retail-chains" role="tab" aria-controls="nav-retail-chains" aria-selected="true">{{ 'IMPORT_AND_EXPORT.RETIAL_CHAINS' | translate }}</a>
                      <a class="nav-link" id="nav-other-tab" data-toggle="tab" href="#nav-other" role="tab" aria-controls="nav-other" aria-selected="false">{{ 'OTHER' | translate }}</a>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-retail-chains" role="tabpanel" aria-labelledby="nav-retail-chains-tab">

                        <br>
                        <ul class="list-group">
                            <li class="list-group-item" *ngFor="let retail of retails">
                                <div class="item-content">
                                    <a routerLink="/export/integrations/{{retail.id}}">
                                        <div>{{ retail.name[language] }}</div>
                                    </a>
                                </div>
                            </li>
                        </ul>

                    </div>
                    <!-- <div class="tab-pane fade" id="nav-other" role="tabpanel" aria-labelledby="nav-other-tab">...</div> -->
                </div>

            </div>
        </div>

    </div>
</div>